import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

// Define a type for the slice state
export interface SystemState {
  theme: string;
  showInfoTooltips: boolean;
}

// Define the initial state using that type
const initialState: SystemState = {
  theme: "light",
  showInfoTooltips: localStorage.getItem("show_info_tooltips") !== "false",
};

export const systemSlice = createSlice({
  name: "system",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    changeTheme(
      state,
      action: PayloadAction<{
        theme: string | 'light';
      }>
    ) {
      state.theme = action.payload.theme;
    },
    setInfoTooltips(state, action: PayloadAction<boolean>) {
      state.showInfoTooltips = action.payload;
      localStorage.setItem("show_info_tooltips", action.payload ? "true" : "false");
    },
  },
});

export const { changeTheme, setInfoTooltips } = systemSlice.actions;

// Other code such as selectors can use the imported `RootState` type

export const getSystemState = (state: RootState) => state.system;

export default systemSlice.reducer;
